const { setHeaderSize } = require('@redux/modules/global')
const { useLayoutEffect } = require('react')
const { useDispatch } = require('react-redux')

const useHeaderSize = headerElement => {
  const dispatch = useDispatch()
  useLayoutEffect(() => {
    if (!headerElement) return

    const updateHeaderSize = () => {
      const { height } = headerElement.getBoundingClientRect()
      dispatch(setHeaderSize(height))
    }

    updateHeaderSize()
    // eslint-disable-next-line no-undef
    const resizeObserver = new ResizeObserver(() => {
      updateHeaderSize()
    })
    resizeObserver.observe(headerElement)

    // eslint-disable-next-line
    return () => {
      resizeObserver.unobserve(headerElement)
      resizeObserver.disconnect()
    }
    // eslint-disable-next-line
  }, [headerElement])
}

export default useHeaderSize
